import React, { Component } from "react";

import Cheque from "./components/Cheque/Cheque";
import Card from "./components/Card/Card";
import { getProductById } from "./api";

import "./App.css";
import { CARD_CATEGORY_ID } from "./Constants";

class App extends Component {
  state = {
    product: null,
  };

  componentDidMount() {
 
    const id = (process.env.REACT_APP_STAGE==='dev')? 6 :  document.getElementById("product_id").value;


    getProductById(id).then(async (product) => {
      
     // console.log(product);
      //let category = await getCategoryById(product.product.id_category_default);
     // product.product.id = id;
    //  product.product.category = category.category.name;
    this.setState({ product: product.product });
    });
  }

  render() {
    const { product } = this.state;
    if (!product) return <div></div>;

    return (
      <div className="App">
        {+product.id_category_default === CARD_CATEGORY_ID  ? (
          <Card product={product} />
        ) : (
          <Cheque product={product} />
        )}
      </div>
    );
  }
}

export default App;
